import React from 'react';
import styles from './About.module.css';

interface Stat {
  value: string;
  label: string;
}

const STATS: Stat[] = [
  { value: '7+',    label: 'Years Experience' },
  { value: '99.9%', label: 'System Uptime Achieved' },
  { value: '30%',   label: 'API Response Improvement' },
  { value: '3',     label: 'Cloud Platforms' },
];

const TAGS = ['AWS Certified', 'IELTS 6.5', 'Sweden-based', 'Remote Ready'];

export default function About(): React.ReactElement {
  return (
    <section id="about" className={styles.section}>
      <div className={styles.inner}>
        <h2 className={styles.heading}>
          <span className={styles.headingNum}>01.</span>
          About Me
          <div className={styles.headingLine} />
        </h2>

        <div className={styles.grid}>
          {/* Text */}
          <div className={styles.textBlock}>
            <p>
              I'm a <strong>Senior Fullstack Developer</strong> with 7+ years of experience
              designing and building scalable microservices in cloud-native environments.
            </p>
            <p>
              My expertise spans <strong>event-driven architecture</strong> (Kafka, SQS),
              REST API design, AWS cloud migration, CI/CD pipelines, and production monitoring.
              I've worked across healthcare, education, and fintech domains — delivering
              resilient systems at scale.
            </p>
            <p>
              Currently based in{' '}
              <span className={styles.accentText}>Sweden</span>,
              I'm an <strong>AWS Certified Solutions Architect</strong> with an IELTS score
              of 6.5. Open to Senior / Lead Engineering roles in Europe.
            </p>
            <div className={styles.tags}>
              {TAGS.map((tag) => (
                <span key={tag} className={styles.tag}>{tag}</span>
              ))}
            </div>
          </div>

          {/* Photo + Stats */}
          <div className={styles.photoCol}>
            <div className={styles.photoFrame}>
              <div className={styles.photoCornerTL} aria-hidden="true" />
              <img
                src="/profile.jpeg"
                alt="Tharanga Mahavila"
                className={styles.photo}
              />
            </div>
            <div className={styles.statsGrid}>
              {STATS.map(({ value, label }) => (
                <div key={label} className={styles.statCard}>
                  <div className={styles.statValue}>{value}</div>
                  <div className={styles.statLabel}>{label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
